import { BoardSchema } from '@contracts/schemas/board.schema';
import type { Board, BoardRepository } from '@/application/ports/BoardRepository';
import { request } from '../client';

export class HttpBoardRepository implements BoardRepository {
  async board(): Promise<Board> {
    return request('/board', { schema: BoardSchema });
  }
}
